import type { HubApi, LinkedTool } from '../api';

/**
 * Open a linked tool in a new tab. SSO tools (`launch`) first ask the hub for a one-time launch URL
 * (`POST /links/{id}/launch`). The tab is opened synchronously inside the click so popup blockers allow it,
 * then navigated once the URL is known (closed again when the launch fails). `opener` is cut by hand, since
 * `noopener` would give us no handle to navigate.
 */
export async function openTool(tool: LinkedTool, api: Pick<HubApi, 'launchLink'>, win: Window = window) {
  if (!tool.launch) {
    win.open(tool.url, '_blank', 'noopener');
    return;
  }
  const tab = win.open('about:blank', '_blank');
  if (tab) tab.opener = null;
  try {
    const { url } = await api.launchLink(tool.id);
    if (tab) tab.location.href = url;
    else win.open(url, '_blank', 'noopener');
  } catch (e) {
    tab?.close();
    throw e;
  }
}
